module.exports = __webpack_public_path__ + "img/dingwei@3x.85c6ce40.png";